import { startFunnelSession, recordFunnelStep } from "@/utils/behaviorTracker";
import { safeTrack } from "./track";
import { PAGE_KEYS } from "./pageKeys";

const PAGE_KEY = PAGE_KEYS.KYC_MAIN;

export function trackKycPageView({ pagePath, pageKey = PAGE_KEY }) {
  startFunnelSession("kyc");
  recordFunnelStep(1);
  return safeTrack("kyc_page_view", {
    page: pagePath || "",
    properties: { page_key: pageKey },
  });
}

export function trackKycVerifyStart({ provider, pagePath, pageKey = PAGE_KEY }) {
  recordFunnelStep(2);
  return safeTrack("kyc_verify_start", {
    page: pagePath || "",
    properties: { page_key: pageKey, provider },
  });
}

export function trackKycSubmit({ provider, pagePath, pageKey = PAGE_KEY }) {
  recordFunnelStep(3);
  return safeTrack("kyc_submit", {
    page: pagePath || "",
    properties: { page_key: pageKey, provider },
  });
}
